<app-attendee-header class="organizer__header"></app-attendee-header>

<main id="main-content" class="organizer__content">
  <app-organizer-description
    class="organizer__description"
    [name]="organization?.name"
    [logo]="organization?.logo"
    [description]="organization?.description"
    [createdAt]="organization?.createdAt"
    [id]="organization?.identifier"
  ></app-organizer-description>

  <app-router-tab-bar class="organizer__tabs" [tabBarLinks]="tabBarlinks">
    <router-outlet></router-outlet>
  </app-router-tab-bar>
</main>

<app-attendee-footer></app-attendee-footer>
